import React from "react";

const ArrowLeftIcon = () => {
    return (
        <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.7084 9.29171C10.7917 9.20837 10.8334 9.11115 10.8334 9.00004C10.8334 8.88893 10.7917 8.79171 10.7084 8.70837L8.37502 6.37504C8.25002 6.25004 8.10058 6.21893 7.92669 6.28171C7.75335 6.34393 7.66669 6.47226 7.66669 6.66671L7.66669 11.3334C7.66669 11.5278 7.75335 11.6562 7.92669 11.7184C8.10058 11.7812 8.25002 11.75 8.37502 11.625L10.7084 9.29171ZM16.8334 9.00004C16.8334 10.1528 16.6145 11.2362 16.1767 12.25C15.7395 13.2639 15.1459 14.1459 14.3959 14.8959C13.6459 15.6459 12.7639 16.2395 11.75 16.6767C10.7361 17.1145 9.6528 17.3334 8.50002 17.3334C7.34724 17.3334 6.26391 17.1145 5.25002 16.6767C4.23613 16.2395 3.35419 15.6459 2.60419 14.8959C1.85419 14.1459 1.2603 13.2639 0.82252 12.25C0.385298 11.2362 0.166687 10.1528 0.166687 9.00004C0.166687 7.84726 0.385298 6.76393 0.82252 5.75004C1.2603 4.73615 1.85419 3.85421 2.60419 3.10421C3.35419 2.35421 4.23613 1.7606 5.25002 1.32337C6.26391 0.885597 7.34724 0.666708 8.50002 0.666708C9.6528 0.666708 10.7361 0.885597 11.75 1.32337C12.7639 1.7606 13.6459 2.35421 14.3959 3.10421C15.1459 3.85421 15.7395 4.73615 16.1767 5.75004C16.6145 6.76393 16.8334 7.84726 16.8334 9.00004Z"
                fill="#0075FF"
            />
        </svg>
    );
};

export default ArrowLeftIcon;
